import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {NotificationsSystemBase} from '../models/notifications-system-base.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationSystemsRegistryService {
  private _notificationSystemRegistered: BehaviorSubject<[string, NotificationsSystemBase]>;
  private _notificationSystemUnregistered: BehaviorSubject<string>;

  constructor() {
    this._notificationSystemRegistered = new BehaviorSubject<[string, NotificationsSystemBase]>(null);
    this._notificationSystemUnregistered = new BehaviorSubject<string>(null);
  }

  private _registry: { [key: string]: NotificationsSystemBase } = {};

  get registry(): { [p: string]: NotificationsSystemBase } {
    return this._registry;
  }

  register(key, notificationSystem: NotificationsSystemBase) {
    // Check if the key already being used
    if (this._registry[key]) {
      console.error(`The navigation with the key '${key}' already exists. Either unregister it first or use a unique key.`);

      return;
    }

    // Add to the registry
    this._registry[key] = notificationSystem;

    // Notify the subject
    this._notificationSystemRegistered.next([key, notificationSystem]);
  }

  unregister(key) {
    // Check if the navigation exists
    if (!this._registry[key]) {
      console.warn(`The navigation with the key '${key}' doesn't exist in the registry.`);
    }

    // Unregister the sidebar
    delete this._registry[key];

    // Notify the subject
    this._notificationSystemUnregistered.next(key);

  }

  getNotificationSystem(key) {
    if (!this._registry[key]) {
      console.warn(`The navigation with the key '${key}' doesn't exist in the registry.`);

      return;
    }

    return this._registry[key];

  }

  unSubscribeAll() {
    for (const n  in this.registry) {
      if (n) {
        this.registry[n].unlisten();
      }
    }
  }
}
